import { render, staticRenderFns } from "./ModalInquiryReview.vue?vue&type=template&id=46fe7c43&"
import script from "./ModalInquiryReview.vue?vue&type=script&lang=js&"
export * from "./ModalInquiryReview.vue?vue&type=script&lang=js&"
import style0 from "./ModalInquiryReview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports